/**
 * Created by BFR on 16/12/2017.
 */
define('numbersRouter',[
    'require',
    'exports',
    'module',
    'logger',
    'underscore',
    'marionette',
    'app',
    'itemPagesNameMixin'
], function (
    require,
    exports,
    module,
    Logger,
    _,
    Marionette,
    App,
    ItemPagesNameMixin
) {
    'use strict';

    var NumbersRouter = Marionette.AppRouter.extend({
        appRoutes: {
            'phone/numbers': 'showListView'
        },
        onRoute: function() {
            $('#customer-comments-sidebar-region').hide();
        }
    });

    var API = {

        showListView: function () {
            require([
                'numbersListController',
                'contentShowController'
            ], function (
                ListController,
                ContentShowController
            ) {
                ContentShowController.showContent().done(function () {
                    ListController.show();
                    App.execute('set:active:nav:item', ItemPagesNameMixin.PHONE_NUMBERS);
                });
            });
        }
    };

    App.on('before:start', function () {
        new NumbersRouter({
            controller: API
        });
    });

    module.exports = NumbersRouter;
});
